<template>
  <div class="container" :class="equipmentsData && equipmentsData.length === 0 ? '' : 'have'">
    <div class="no-equipment" v-if="equipmentsData && equipmentsData.length === 0">
      <div class="pic" :style="{backgroundImage: 'url('+imgSrc+')'}"></div>
      <p class="top-text">欢迎来到智能日历</p>
      <p class="bottom-text">未添加设备，请添加</p>
      <button class="btn btn-block" :class="!userId ? 'btn-disable' : ''" @click="addEquipment()">添加</button>
    </div>
    <div class="have-equipment" v-else>
      <!-- <nav-bar leftName="添加设备" rightName="设置" @leftClick="leftClick()" @rightClick="rightClick()"></nav-bar> -->
      <main-nav @addEquipment="leftClick" @goSetting="rightClick"></main-nav>
      <div class="canlender">
        <mmc-canlender :channels="channels" :canlenderInfo="canlenderInfo" :weatherInfo="weatherInfo"></mmc-canlender>
      </div>
      <button class="btn btn-block btn-buttom" @click="switchOver()">日历频道列表</button>
    </div>
<!--    <div id="block" class="float-img" :style="{backgroundImage: 'url('+floatSrc+')'}" @click="goGood"></div>-->
  </div>

</template>
<script>
import axios from 'axios'
import Common from '../../assets/js/common.js'
import MainNav from './components/nav.vue'
import MmcCanlender from '../../canlender/mmc/mmc.vue'
var USER_INFO = localStorage.getItem('max_userInfo')
var OPEN_ID = localStorage.getItem('max_openId')
var _local = window.location.href
var api = process.env.BASE_URL
// var deviceId = localStorage.getItem('max_device_id')
var isLocal = Common.getEvn()
export default {
  components: {
    MainNav,
    MmcCanlender
  },
  data () {
    return {
      equipmentsData: [],
      userId: localStorage.getItem('max_userId'),
      wxError: localStorage.getItem('wx_error'),
      timer: null,
      timerE: null,
      url: '',
      deviceId: localStorage.getItem('max_device_id'),
      deviceIdExB: localStorage.getItem('max_device_id_ex'),
      deviceIdNm: localStorage.getItem('max_device_name'),
      equipmentId: [],
      equipmentEx: [],
      equipmentNm: [],
      formPage: this.$route.query.goPage,
      imgSrc: Common.staticHref() + 'img/canlender.jpg',
      floatSrc: Common.staticHref() + 'img/goodrepu.png',
      channels: [],
      canlenderInfo: {
        avoid: '开工',
        countdown: '',
        datelist: '正在获取日历信息 00:00:00+00:00',
        easy: '结婚',
        festival: null,
        lunar_day: '',
        lunar_mone: '',
        lunar_year: '',
        lunarcal: '',
        week: ''
      },
      weatherInfo: {
        air_quality: 3,
        temperature: 12,
        time: 1575068400,
        weather_status: 4
      }
    }
  },
  mounted () {
    // this.drag()
    Common.setTitle('智能日历')
    window.history.pushState(null, null, '#/')
    let _this = this
    window.removeEventListener('popstate', _this.goLink)
    window.addEventListener('popstate', _this.goLink)
    if (isLocal === 'local') {
      this.getEquipmentList()
    } else {
      // if (!OPEN_ID) {
      this.loginWithOpenid(_local)
      // }
      // else{
        // alert('open_id: ' + OPEN_ID)
      //   this.login(OPEN_ID)
      // }
    }
  },
  destroyed () {
    setTimeout(() => {
      let _this = this
      window.removeEventListener('popstate', _this.goLink)
    }, 1000)
  },
  activated () {
    Common.setTitle('智能日历')
    if (sessionStorage.getItem('isfirst') === 'no') {
      window.history.pushState(null, null, '#/')
      let _this = this
      window.removeEventListener('popstate', _this.goLink)
      window.addEventListener('popstate', _this.goLink)
      this.userId = localStorage.getItem('max_userId')
      this.deviceId = localStorage.getItem('max_device_id')
      this.deviceIdExB = localStorage.getItem('max_device_id_ex')
      // console.log('ff')
      if (this.userId) {
        this.getEquipmentList()
      }
    } else {
      sessionStorage.setItem('isfirst', 'no')
    }
  },
  deactivated () {
    setTimeout(() => {
      let _this = this
      window.removeEventListener('popstate', _this.goLink)
    }, 1000)
  },
  methods: {
    leftClick () {
      this.$router.replace({path: '/EquipmentList'})
    },
    rightClick () {
      this.$router.replace({path: '/Setting', query: {goPage: 'Main'}})
    },
    goLink () {
      window.history.pushState(null, null, '#/')
    },
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    // 直接使用openid登陆
    login (openId) {
      this.toast = this.$createToast({
        time: 0,
        txt: '正在登录',
        mask: true
      }).show()
      axios.post(api + '/mmc/api/user/login/', {
        'openid': openId
      })
        .then(this.loginSuccess)
        .catch(this.loginError)
    },
    loginSuccess (res) {
      this.toast.hide()
      let _res = res.data
      // alert('loginSuccess' + JSON.stringify(_res))
      if (_res.result === 0) {
        USER_INFO = JSON.stringify(_res.mmcuser)
        localStorage.setItem('max_userInfo', USER_INFO)
        localStorage.setItem('max_userId', _res.mmcuser.userid)
        this.userId = _res.mmcuser.userid
        this.getEquipmentList()
      } else if (_res.result === 1) {
        this.toast = this.$createToast({
          txt: '该微信用户还没有注册',
          type: 'txt'
        }).show()
        this.loginWithOpenid(_local)
        // this.$router.replace({path: '/login'})
      } else if (_res.result === 4) {
        this.toast = this.$createToast({
          txt: '验证码错误',
          type: 'txt'
        }).show()
      } else if (_res.result === 9) {
        this.toast = this.$createToast({
          txt: 'openid为空',
          type: 'txt'
        }).show()
      } else {
        this.toast.hide()
        this.toast = this.$createToast({
          txt: '登录异常！',
          type: 'txt'
        }).show()
      }
    },
    loginError () {
      this.toast.hide()
      this.toast = this.$createToast({
        txt: '访问接口出错！登录失败',
        type: 'txt'
      }).show()
    },
    // 获取openid登陆
    loginWithOpenid (url) {
      var __code = Common.getQueryVariable('code')
      // alert('code: ' + __code)
      if (__code == null || __code === '' || !__code) {
        window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + localStorage.getItem('appId') + '&redirect_uri=' + encodeURIComponent(url) + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect')
      } else {
        this.toast = this.$createToast({
          time: 0,
          txt: '正在登录',
          mask: true
        }).show()
        // alert('code' + __code)
        if (Common.getEvn() === 'local') {
          axios.get('/mmc/api/wx_user/get_openid/?code=' + __code)
          .then(this.loginWithOpenIdsucc)
          .catch(this.loginWithOpenIdError)
        } else {
          // alert('get_openid准备调用')
          axios.get(api + '/mmc/api/wx_user/get_openid/?code=' + __code)
          .then(this.loginWithOpenIdsucc)
          .catch(this.loginWithOpenIdError)
        }
      }
    },
    loginWithOpenIdsucc (res) {
      // alert('openid成功')
      this.toast.hide()
      let _res = res.data
      OPEN_ID = _res.openid
      // alert('open_id: ' + OPEN_ID)
      if (OPEN_ID && OPEN_ID !== '') {
        localStorage.setItem('max_openId', OPEN_ID)
      }
      if (_res.result === 0) { // 登陆成功
        USER_INFO = JSON.stringify(_res.mmcuser)
        localStorage.setItem('max_userInfo', USER_INFO)
        localStorage.setItem('max_userId', _res.mmcuser.userid)
        this.userId = _res.mmcuser.userid
        this.getEquipmentList()
      } else if (_res.result === 40163 || _res.result === 40001 || _res.result === 40029) { // code已被使用过或者已经过期
        window.location.href = window.location.href.split('?')[0]
      } else if (_res.result === 2) {
        this.$router.replace({path: '/login'})
      } else {
        this.toast = this.$createToast({
          txt: '登录失败,' + _res.message,
          type: 'txt'
        }).show()
      }
    },
    loginWithOpenIdError () {
      this.toast.hide()
      this.toast = this.$createToast({
        txt: '服务器异常，登录失败',
        type: 'txt'
      }).show()
    },
    addEquipment () {
      if (!this.userId) return
      this.$router.push({path: '/StepOne'})
    },
    getEquipmentList () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中',
        mask: true
      }).show()
      if (Common.getEvn() === 'local') {
        axios.get('/Calendar/api/device/get/device/list/?user_id=' + this.userId)
        .then(this.getEquipmentListSucc)
        .catch(this.getEquipmentListError)
      } else {
        axios.get(api + '/Calendar/api/device/get/device/list/?user_id=' + this.userId)
        .then(this.getEquipmentListSucc)
        .catch(this.getEquipmentListError)
      }
    },
    getEquipmentListSucc (res) {
      // alert('列表请求成功' + JSON.stringify(res.data.data_latest))
      let _res = res.data
      if (_res.result === 0) {
        let datas = _res.data_latest
        this.equipmentsData = datas
        let len = datas.length
        if (len > 0) {
          this.equipmentId.splice(0, this.equipmentId.length)
          for (var i = 0; i < len; i++) {
            this.equipmentId.push(datas[i].id)
            this.equipmentEx.push(datas[i].device_id_ex)
            this.equipmentNm.push(datas[i].name)
            if (datas[i].id === Number(this.deviceId)) {
              datas[i].active = true
              localStorage.setItem('max_device_id_ex', datas[i].device_id_ex)
              localStorage.setItem('max_device_name', datas[i].name)
              // console.log('当前的device_id_ex' + datas[i].device_id_ex)
              // console.log('当前的device_name' + datas[i].name)
            }
          }
          if (_local.indexOf('device_id_ex') > -1) {
            let deviceIdExF = _local.split('=')[1]
            let deviceIdEx = deviceIdExF.indexOf('#') > -1 ? deviceIdExF.split('#')[0] : deviceIdExF
            deviceIdEx = deviceIdExF.indexOf('&') > -1 ? deviceIdExF.split('&')[0] : deviceIdExF
            if (deviceIdEx) {
              let index = this.equipmentEx.indexOf(deviceIdEx)
              if (this.equipmentEx.indexOf(deviceIdEx) > -1) {
                this.deviceId = this.equipmentId[index]
                this.deviceIdExB = this.equipmentEx[index]
                this.deviceIdNm = this.equipmentNm[index]
                localStorage.setItem('max_device_id', this.deviceId)
                // localStorage.setItem('max_device_id_ex', this.deviceIdExB)
                window.location.replace(_local.split('?')[0])
                this.getCanlenderInfo(Number(this.deviceId))
                // console.log('当前的1------>>>' + this.deviceId)
              } else {
                localStorage.removeItem('max_device_id')
                localStorage.removeItem('max_device_id_ex')
                this.$router.push({path: '/StepTwo', query: {pageName: 'Main', deviceIdEx: deviceIdEx}})
                // console.log('当前的2------>>>' + this.deviceId)
              }
            }
          } else if (!(Number(this.deviceId)) || ((Number(this.deviceId) && this.equipmentId.indexOf(Number(this.deviceId)) === -1))) {
            this.deviceId = this.equipmentId[len - 1]
            this.deviceIdExB = this.equipmentEx[len - 1]
            this.deviceIdNm = this.equipmentNm[len - 1]
            localStorage.setItem('max_device_id', this.deviceId)
            localStorage.setItem('max_device_id_ex', this.deviceIdExB)
            localStorage.setItem('max_device_name', this.deviceIdNm)
            this.getCanlenderInfo(Number(this.deviceId))
            // console.log('当前的3------>>>' + this.deviceId)
            // console.log('当前的3------>>>' + this.deviceIdExB)
            // console.log('当前的3------>>>' + this.deviceIdNm)
          } else if ((Number(this.deviceId) && this.equipmentId.indexOf(Number(this.deviceId)) > -1)) {
            this.getCanlenderInfo(Number(this.deviceId))
            // console.log('当前的4------>>>' + this.deviceId)
            // console.log('当前的4------>>>' + this.deviceIdExB)
          }
        } else if (len === 0) {
          localStorage.removeItem('max_hot_name')
          localStorage.removeItem('max_hot_pass')
          if (_local.indexOf('device_id_ex') > -1) {
            let deviceIdExF = _local.split('=')[1]
            let deviceIdEx = deviceIdExF.indexOf('#') > -1 ? deviceIdExF.split('#')[0] : deviceIdExF
            deviceIdEx = deviceIdExF.indexOf('&') > -1 ? deviceIdExF.split('&')[0] : deviceIdExF
            // console.log('当前的5------>>>' + this.deviceId)
            if (deviceIdEx) {
              localStorage.removeItem('max_device_id')
              localStorage.removeItem('max_device_id_ex')
              this.$router.push({path: '/StepTwo', query: {pageName: 'Main', deviceIdEx: deviceIdEx}})
              // console.log('当前的6------>>>' + this.deviceId)
            }
          }
        }
        this.toast.hide()
      } else {
        this.toast.hide()
      }
    },
    getEquipmentListError () {
      this.toast.hide()
      // Common.toast(this, '调用接口失败！获取设备列表出错')
    },
    // 获取日历信息
    getCanlenderInfo (deviceId) {
      // console.log('传的时间参数---->>>>' + Common.getUtcTime(null, 1000))
      if (Common.getEvn() === 'local') {
        axios.post('/Calendar/api/channel/get/calendar/info/', {
          'device_id': deviceId,
          'time_stamp': Common.getUtcTime(null, 1000)
        })
        .then(this.getCanlenderInfoSucc)
        .catch(this.getCanlenderInfoErr)
      } else {
        axios.post(api + '/Calendar/api/channel/get/calendar/info/', {
          'device_id': deviceId,
          'time_stamp': Common.getUtcTime(null, 1000)
        })
        .then(this.getCanlenderInfoSucc)
        .catch(this.getCanlenderInfoErr)
      }
    },
    getCanlenderInfoSucc (res) {
      this.toast.hide()
      let _res = res.data
      if (!_res) return
      if (_res.result === 0) {
        if (_res.channels) {
          this.channels = _res.channels
        }
        if (_res.calendar_info) {
          this.canlenderInfo = _res.calendar_info
          try {
            localStorage.setItem('max_channel_id', _res.calendar_info.channel_id)
          } catch (error) {
            console.log(error)
          }
        }
        if (_res.weather_info.time) {
          this.weatherInfo = _res.weather_info
        } else {
          this.weatherInfo = {
            time: 0
          }
        }
        // console.log(this.canlenderInfo)
        // console.log(this.weatherInfo)
      } else if (_res.result === 1) {
        if (_res.channels) {
          this.channels = _res.channels
        }
        if (_res.calendar_info) {
          this.canlenderInfo = _res.calendar_info
          try {
            localStorage.setItem('max_channel_id', _res.calendar_info.channel_id)
          } catch (error) {
            console.log(error)
          }
        }
        this.weatherInfo = {
          time: 0,
          message: _res.message
        }
      } else {
        this.toast = this.$createToast({
          txt: _res.message,
          type: 'txt'
        }).show()
      }
      this.channels.sort(this.compare('channel_id'))
    },
    getCanlenderInfoErr (error) {
      this.toast.hide()
      console.log(error)
    },
    sortNumber (a, b) {
      return (b - a)
    },
    switchOver () {
      this.$router.push({path: '/CutStyle', query: {fromPage: 'Main'}})
    },
    goGood () {
      window.location.replace('https://www.yaoyaola.cn/tbhb/reqhbndf_news2?wid=12188')
    },
    drag () {
      let blockElem = document.getElementById('block')
      let oW
      let oH
      let clientWidth = document.documentElement.clientWidth
      let clientHeight = document.documentElement.clientHeight
      let blockW = blockElem.offsetWidth
      let blockH = blockElem.offsetHeight
      // 绑定touchstart事件
      blockElem.addEventListener('touchstart', function (e) {
        let touches = e.touches[0]
        oW = touches.clientX - blockElem.offsetLeft
        oH = touches.clientY - blockElem.offsetTop
      }, false)
      blockElem.addEventListener('touchmove', function (e) {
        e.preventDefault()
        let touches = e.touches[0]
        let oLeft = touches.clientX - oW
        let oTop = touches.clientY - oH
        if (oLeft < 0) {
          oLeft = 0
        } else if (oLeft > clientWidth - blockW) {
          oLeft = clientWidth - blockW
        }
        if (oTop < 0) {
          oTop = 0
        } else if (oTop > clientHeight - blockH) {
          oTop = clientHeight - blockH
        }
        blockElem.style.left = oLeft + 'px'
        blockElem.style.top = oTop + 'px'
      }, false)
      blockElem.addEventListener('touchend', function (e) {
        var endLeft = e.changedTouches[0].pageX
        if (endLeft > clientWidth / 2) {
          blockElem.style.left = (clientWidth - blockW - 5) + 'px'
        } else if (endLeft < clientWidth / 2) {
          blockElem.style.left = 5 + 'px'
        }
      }, false)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.have
  background #ffffff
.no-equipment
  width 100%;
  height 100%;
  background #ffffff;
  padding 13.6vh 15px 0;
  box-sizing border-box;
  .pic
    height 54.06vh
    width calc(54.06vh * 0.76)
    background-position center center
    background-repeat no-repeat
    background-size contain
    margin 0 auto;
  p
    text-align center;
    color #333333;
  .top-text
    height 26px
    line-height 26px
    font-size 16px
    padding-top 37px
  .bottom-text
    height 26px
    line-height 26px
    font-size 16px
  .btn
    position absolute;
    bottom 23px;
    width calc(100% - 30px)
.btn-buttom
  position fixed
  bottom 5px
  left 50%
  margin-left -180px
  width 360px
  z-index 99999
.float-img
  backgroundImg()
  width:80px;
  height:80px;
  position: fixed;
  right: 2%;
  bottom: 13%;
  z-index: 500;
</style>



// WEBPACK FOOTER //
// src/pages/Main/Main.vue